import request from '@/api/config/request'

const prex = "api/admin/gestao/remessa_tse";

export function listRemessaTse() {
    return request({
        url: `${prex}`,
        method: 'get'
    })
}

export function remessaTseNotas(data) {
    return request({
        url: `${prex}/notas`,
        method: 'post',
        data
    })
}

export function remessaTseGerar(data) {
    return request({
        url: `${prex}/gerar`,
        method: 'post',
        data
    })
}
